/* Size guide behaviour. Rendered by snippets/size-guide.liquid. (Nicolai, 2026-09-23)

   The size-system column and the cm/in toggle are done client-side on purpose: the
   numbers are all derived from the same rows, so re-rendering in place avoids a
   second request and keeps the table honest - there is one set of measurements and
   two ways of looking at it. */
(function () {
  // Letter -> the number each market prints on the label. Conversions between these
  // scales are not standardised (published charts disagree by a full size), so this
  // is the common convention and the panel says it is a guide.
  // Womenswear size numbers. EU and ES share a scale; FR runs +2 and IT +4 - those
  // offsets are real, and getting them wrong is how an Italian shopper reading "38"
  // orders two sizes too small.
  // UK and US carry real size numbers, per Nicolai 2026-09-25.
  //
  // The reference brand prints an identical column for UK and US - 32, 34, 36/38, 38/40 -
  // which cannot be two different markets' sizes. It is the chest in INCHES, which
  // menswear uses for both, and that brand is menswear. Womenswear does not work that
  // way: a UK 10 is a US 6, two full sizes apart, so the two columns have to differ.
  // These are the standard womenswear conversions against EU 34-46.
  var SYSTEMS = {
    EU: { XXS: 32, XS: 34, S: 36, M: 38, L: 40, XL: 42, XXL: 44 },
    ES: { XXS: 32, XS: 34, S: 36, M: 38, L: 40, XL: 42, XXL: 44 },
    FR: { XXS: 34, XS: 36, S: 38, M: 40, L: 42, XL: 44, XXL: 46 },
    IT: { XXS: 36, XS: 38, S: 40, M: 42, L: 44, XL: 46, XXL: 48 },
    UK: { XXS: 4,  XS: 6,  S: 8,  M: 10, L: 12, XL: 14, XXL: 16 },
    US: { XXS: 0,  XS: 2,  S: 4,  M: 6,  L: 8,  XL: 10, XXL: 12 },
    AU: { XXS: 4,  XS: 6,  S: 8,  M: 10, L: 12, XL: 14, XXL: 16 }
  };

  // No system prints a waist in inches any more. It was the honest answer while UK and US
  // had no number, and it is redundant now that they do - the inches toggle already turns
  // every measurement into inches.
  var INCH_WAIST = {};


  function fmt(cm, unit) {
    // Halves in cm too, not just inches. Shoes grade 0.5 cm, so rounding to whole
    // centimetres turned 23.0-23.5 into "23 - 24" and 23.5-24.0 into "24 - 24".
    if (unit === 'cm') {
      var c = Math.round(cm * 2) / 2;
      return c % 1 === 0 ? String(c) : c.toFixed(1);
    }
    // Half inches - a tape shows halves, and the app's 27,559 read as noise. A whole
    // number is written without the .0: 27, not 27.0.
    var n = Math.round((cm / 2.54) * 2) / 2;
    return n % 1 === 0 ? String(n) : n.toFixed(1);
  }

  function render(panel) {
    var unitBtn = panel.querySelector('.sg-unit__btn.is-active');
    var unit = unitBtn ? unitBtn.dataset.sgUnit : 'cm';
    // Shoe charts have no size-system selector: EU 36-43 does not convert through the
    // clothing tables. Reading .value off the missing select threw here and left every
    // measurement cell blank - the table rendered with correct headings and no numbers.
    var sel = panel.querySelector('[data-sg-system]');
    var sys = sel ? sel.value : 'EU';
    var map = SYSTEMS[sys];

    panel.querySelectorAll('[data-sg-range]').forEach(function (td) {
      var lo = fmt(parseFloat(td.dataset.min), unit);
      var hi = fmt(parseFloat(td.dataset.max), unit);
      td.textContent = lo + ' - ' + hi;
    });
    // Garment measures - inseam, length, thigh - are a single number, and still have to
    // follow the cm/inches toggle.
    panel.querySelectorAll('[data-sg-value]').forEach(function (td) {
      var v = parseFloat(td.dataset.value);
      td.textContent = isNaN(v) ? '-' : fmt(v, unit);
    });
    panel.querySelectorAll('[data-sg-sizenum]').forEach(function (td) {
      var size = (td.dataset.size || '').toUpperCase();
      // UK and US print the waist in inches - but only where there IS a waist. Tops carry
      // a chest and nothing else, and a dash in every row of those columns told the
      // customer less than the size letter she is already looking at.
      if (INCH_WAIST[sys] && td.dataset.waistMax) {
        var cm = parseFloat(td.dataset.waistMax);
        if (!isNaN(cm)) { td.textContent = 'W' + Math.round(cm / 2.54); return; }
      }
      // UK and US have no letter map on purpose - see INCH_WAIST above. On a chart with
      // no waist to convert there is nothing honest to print, so the size itself is
      // echoed. Falling back to SYSTEMS.EU here labelled the EU numbers "UK", telling a
      // British customer her size was a 36.
      var v = map ? map[size] : undefined;
      // Paired and ranged labels - XS/S, M/L, 36-37 - are in no system's table either.
      td.textContent = v === undefined ? (td.dataset.size || '-') : v;
    });
  }

  function wire(root) {
    var overlay = root.querySelector('[data-sg-overlay]');
    var panel = root.querySelector('[data-sg-panel]');
    if (!overlay || !panel) return;

    // Move the overlay to <body>. It is rendered deep inside the product template, and an
    // ancestor there creates a stacking context that the site header outranks - so the nav
    // painted straight over the panel's title however high its own z-index went. Nothing
    // above body can trap it once it lives here.
    if (overlay.parentNode !== document.body) document.body.appendChild(overlay);

    function open() { overlay.hidden = false; document.body.classList.add('sg-locked'); render(panel); }
    function close() { overlay.hidden = true; document.body.classList.remove('sg-locked'); }

    document.querySelectorAll('[data-sg-open]').forEach(function (b) { b.addEventListener('click', open); });
    panel.querySelector('[data-sg-close]').addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });

    panel.querySelectorAll('.sg-unit__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        panel.querySelectorAll('.sg-unit__btn').forEach(function (o) { o.classList.toggle('is-active', o === b); });
        render(panel);
      });
    });
    var sysSel = panel.querySelector('[data-sg-system]');
    if (sysSel) sysSel.addEventListener('change', function () { render(panel); });
    render(panel);
  }

  function init() {
    if (document.querySelector('[data-sg-overlay]')) {
      // tells the stylesheet to hide Mageplaza's trigger on this product only
      document.body.classList.add('sg-has-guide');
    }
    document.querySelectorAll('[data-sg-overlay]').forEach(function (ov) {
      if (ov.dataset.sgWired) return;
      ov.dataset.sgWired = '1';
      wire(ov.parentNode || document);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  new MutationObserver(init).observe(document.documentElement, { childList: true, subtree: true });
  init();
})();
